import ParticipantHighlights from './participant-highlights';

export default class FullRoundHighlights {
	constructor(
		public challengeId: number,
		public participantHighlights: ParticipantHighlights[]
	) {}
}
